export default {
  app: {
    title: 'Wallpapers',
    tagline: 'Search thousands of HD wallpapers',
    searchPlaceholder: 'Search your favorite wallpapers...',
    hotRecommend: 'Hot Recommendations',
    searchResult: 'Search Results',
    noMore: 'No more',
    loadFailed: 'Load Failed',
    retry: 'Retry',
    noWallpapers: 'No wallpapers',
    noResults: 'No wallpapers found',
    tryOtherKeywords: 'Try other keywords',
    categoryPrefix: 'Category',
    download: 'Download',
    preview: 'Preview',
    close: 'Close',
    noWallpapersInCategory: 'No wallpapers in this category',
    timeout: 'Request timeout, please check your network',
    notFound: 'Page Not Found',
    backHome: 'Back to Home',
    dataSource: 'Data Source',
    allRightsReserved: 'All rights reserved.',
    search: 'Search',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    switchLang: 'Switch Language',
  },
  theme: {
    default: 'Default Blue',
    sunset: 'Sunset Orange',
    forest: 'Forest Green',
    ocean: 'Ocean Teal',
    lavender: 'Lavender Purple',
    cherry: 'Cherry Pink',
  },
};
